import { queryOptions, useMutation, useQueryClient, useSuspenseQuery } from '@tanstack/react-query';
import { Billing, billingQueryKeys } from '#api';

export const billingDetailsQueryOptions = queryOptions({
  queryFn: ({ signal }) => Billing.getBillingDetails({ signal }),
  queryKey: billingQueryKeys.billingDetails,
});

export function useSuspenseBillingDetails() {
  return useSuspenseQuery(billingDetailsQueryOptions);
}

/** {@link usePrefetchBillingDetailsFn} returns a function to trigger the prefetch rather than immediately prefetching on hook call. */
export function usePrefetchBillingDetailsFn() {
  const queryClient = useQueryClient();

  return () => queryClient.prefetchQuery(billingDetailsQueryOptions);
}

/**
 * Calls the API server to create a Stripe setup intent and get a clientSecret,
 * which we will use to render Stripe Elements.
 */
export function useSetupIntentMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: Billing.startSetupIntent,
    onSuccess: () => {
      void queryClient.invalidateQueries(billingDetailsQueryOptions);
    },
  });
}
